import { ISwabShipmentOrder, useDownloadSwabOrdersCsv } from '@nkr/models/hla/swab-shipment-order';
import { ISwabShipmentBatch, useSwabShipmentBatchApi } from '@nkr/models/hla/swab-shipment-batch';
import { useState } from 'react';
import { toast } from "react-toastify";
import { SwabShipmentOrderGrid } from './swab-shipment-order-grid';

interface IProps {
    batch : ISwabShipmentBatch,
}

export const SwabShipmentBatchAccordion = (props: IProps) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const api               = useSwabShipmentBatchApi();
    const downloadApi       = useDownloadSwabOrdersCsv();
    const create            = api.useCreate();
    const update            = api.useUpdate(props.batch.id);
    const isExistingBatch   = props.batch.id > 0;

    const createBatch = async () => {
        const response = await create.submit(props.batch);

        if (response?.isSuccess) {
            toast.success("Batch Created Successfully");
            return;
        }
    };

    const markBatchShipped = async () => {
        const response = await update.submit(props.batch);

        if (response?.isSuccess) {
            toast.success("Batch Marked as Shipped");
            return;
        }
    }

    const toggle = async () => await setIsExpanded(!isExpanded);

    const downloadBatchCsv = async () => {
        await downloadApi.downloadFile({ batchId: props.batch.id, isCsv: true });
    }


    
    return (
        <div className="panel-group" id={`swab-shipment-batch-${props.batch.id}`} role="tablist" aria-multiselectable="true">
            <div className={`panel ${isExistingBatch ? "panel-default" : "panel-primary"}`}>
                <div className="panel-heading" role="tab" id={`swab-shipment-batch-${props.batch.id}-heading`}>
                    <h4 className="panel-title">
                        <div className="row">
                            <div className="col-xs-4" style={{ verticalAlign: 'middle', lineHeight: '30px' }}>
                                <button className="btn btn-sm btn-default" onClick={toggle}>
                                    {isExpanded ? <span className="glyphicon glyphicon-minus" aria-hidden="true"></span> : <span className="glyphicon glyphicon-plus" aria-hidden="true"></span>}
                                </button>
                                &nbsp; &nbsp;
                                {props.batch.id > 0 ? `Batch #${props.batch.id} (${props.batch.orderCount} Orders)` : `${props.batch.orderCount} Pending Batch`}
                            </div>
                            <div className="col-xs-4" style={{ verticalAlign: 'middle', lineHeight: '30px' }}>
                                {isExistingBatch && `Created: ${props.batch.createdDate} by ${props.batch.createdBy}`}
                            </div>
                            <div className="col-xs-4" style={{ textAlign: 'right' }}>
                                {!isExistingBatch && <button className="btn btn-warning" onClick={() => createBatch()}>Create Batch</button>}
                                {isExistingBatch && !props.batch.shippedDate &&
                                    <>
                                        <button className="btn btn-success" onClick={() => markBatchShipped()}>Mark as Shipped</button>
                                        <button className="btn btn-info" onClick={() => downloadBatchCsv()} style={{ marginLeft: 10 }}>
                                            <span className="glyphicon glyphicon-download" aria-hidden="true"></span>
                                        </button>
                                    </>
                                }
                                {props.batch.shippedDate && <span>Shipped: {props.batch.shippedDate} by {props.batch.shippedBy}</span>}
                            </div>
                        </div>
                    </h4>
                </div>
                {isExpanded && (
                    <div className="panel-collapse collapse in" role="tabpanel" aria-labelledby={`swab-shipment-batch-${props.batch.id}-heading`}>
                        <div className="panel-body">
                            <div className="row">
                                <div className="col-xs-12">
                                    <SwabShipmentOrderGrid batchId={props.batch.id} />
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}